import { formatLocalDate } from "src/utils/date/dateUtils";
import {
	defaultPrdInspectResultDto,
	PrdInspectResultDto,
} from "src/dtos/prdInspectResult/prdInspectResultDto";
import { WmsTransportDetailDto } from "src/dtos/wmsTransport/wmsTransportDto";

export interface TQC1020_R01HeaderDto extends WmsTransportDetailDto {
	customCd: string;
	supplierCustomNm: string;
	locationNm: string;
	hasInspectResult: boolean;
}

export interface TQC1020_R01DetailDto extends PrdInspectResultDto {
	inspectorEmpNm: string;
	supplierCustomNm: string;
	badCaseNm: string;
}

export interface TQC1020_R01Dto {
	headerDtoList: TQC1020_R01HeaderDto[];
	detailDtoList: TQC1020_R01DetailDto[] | null;
	basOrderNo?: string;
	basOrderItemNo?: string;
	compCd?: string;
}

export const defaultTQC1020_R01HeaderDto: TQC1020_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	transportNo: '',
	itemNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	transportDt: undefined,
	inoutType: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	unit: '',
	qty: 0,
	cost: 0,
	amt: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',

	customCd: '',
	supplierCustomNm: '',
	locationNm: '',
	hasInspectResult: false,
	inspectionResult: '',

	inserted: false,
	isModified: false,
};

export const defaultTQC1020_R01ResultDto: TQC1020_R01DetailDto = {
	...defaultPrdInspectResultDto,
	inspectDt: formatLocalDate(new Date()),
	inspectorEmpNm: '',
	supplierCustomNm: '',
	badCaseNm: '',
};
